import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("briology_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const trackEvent = async (event_type, extra = {}) => {
  try {
    await api.post("/analytics/event", {
      event_type,
      session_id: getSessionId(),
      path: typeof window !== "undefined" ? window.location.pathname : null,
      ...extra,
    });
  } catch (e) {
    // Analytics events are fire-and-forget; failures shouldn't break user flow.
    // Log for debugging but don't surface to the user.
    console.debug("trackEvent failed", event_type, e);
  }
};

export const getSessionId = () => {
  let sid = localStorage.getItem("briology_sid");
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("briology_sid", sid);
  }
  return sid;
};
